import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import Button from '../../components/ui/Button';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
`;

const LinkBox = styled.div`
  width: 100%;
  padding: 10px 12px;
  border: 1px dashed #c5ccd6;
  border-radius: 8px;
  font-size: 13px;
  word-break: break-all;
  background: #f8fafc;
`;

export default function InviteLinkDialog({ open, link, smsSent, onClose }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard erişimi yoksa kullanıcı linki elle seçer */ }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('visit.inviteLinkTitle')}</DialogTitle>
      <DialogContent>
        <Body>
          {smsSent ? (
            <div>{t('visit.inviteSmsSent')}</div>
          ) : (
            <>
              <div>{t('visit.inviteLinkDesc')}</div>
              {link && <QRCodeSVG value={link} size={180} />}
              {link && <LinkBox>{link}</LinkBox>}
            </>
          )}
        </Body>
      </DialogContent>
      <DialogActions>
        {!smsSent && link && (
          <Button onClick={handleCopy}>{copied ? t('visit.copied') : t('visit.copyLink')}</Button>
        )}
        <Button onClick={onClose}>{t('guest.back')}</Button>
      </DialogActions>
    </Dialog>
  );
}
